import { render } from "./AppTimestamp.vue?vue&type=template&id=051019b6"
import script from "./AppTimestamp.vue?vue&type=script&lang=js"
export * from "./AppTimestamp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__